module.exports = __webpack_public_path__ + "static/marta-7fe44f770fb54f0678e197d6d022630c.jpg";